import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { memo } from 'react';

import { FAVORITE } from '@sportsbook/constants';

import { GameStatusType, RefType } from '../../api/types';
import { isFinishedStatus } from '../../utils/utils';

const FavoriteToggle = dynamic(() =>
  import('../favorite-toggle/favorite-toggle').then(module => module.FavoriteToggle)
);

function FavoriteMatchesToggleUI({ favoriteRef, matchStatus, ...props }) {
  return !isFinishedStatus(matchStatus) ? (
    <FavoriteToggle favoriteRef={favoriteRef} type={FAVORITE.MATCHES} {...props} />
  ) : null;
}

FavoriteMatchesToggleUI.propTypes = {
  favoriteRef: RefType,
  id: PropTypes.number.isRequired,
  matchStatus: GameStatusType.isRequired,
  size: PropTypes.oneOf(['medium', 'large']),
};

FavoriteMatchesToggleUI.defaultProps = {
  favoriteRef: undefined,
  size: 'medium',
};

export const FavoriteMatchesToggle = memo(FavoriteMatchesToggleUI);
